import { render, staticRenderFns } from "./MainTabs.vue?vue&type=template&id=213e97ac"
import script from "./MainTabs.vue?vue&type=script&lang=ts"
export * from "./MainTabs.vue?vue&type=script&lang=ts"
import style0 from "./MainTabs.vue?vue&type=style&index=0&id=213e97ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports